import React, { useEffect, useState } from "react";
import { FaTrash, FaEdit } from "react-icons/fa";
import { IoEyeSharp } from "react-icons/io5";
import ReactPaginate from "react-paginate";
import ProductModal from "./ProductModal";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const GET_CAT_API_BASE_URL = "https://mediapi.onlinepharmaque.in/api/v1";

const GetProduct = () => {
  const [proShowModal, setProShowModal] = useState(false);
  const [productData, setProduct] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQueryName, setSearchQueryName] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [editedProduct, setEditedProduct] = useState(null);
  const [editItemId, setEditItemId] = useState(null);
  const [openModel, setOpenModel] = useState(false);
  const [selectView, setSelectView] = useState(null);

  // ================= FETCH ALL =================
  const fetchProduct = () => {
    fetch(`${GET_CAT_API_BASE_URL}/getAllProduct`)
      .then((res) => res.json())
      .then((data) => setProduct(data.result || []))
      .catch(() => setProduct([]));
  };

  useEffect(() => {
    fetchProduct();
  }, []);

  // ================= SEARCH =================
  const searchProductByName = async (value) => {
  try {
    if (!value) {
      fetchProduct();
      return;
    }

    const res = await fetch(
      `${GET_CAT_API_BASE_URL}/searchproduct?keyword=${value}`
    );

    const data = await res.json();

    setProduct(Array.isArray(data) ? data : []);
  } catch (error) {
    console.log(error);
    setProduct([]);
  }
};





  // debounce
  useEffect(() => {
    const delay = setTimeout(() => {
      searchProductByName(searchQueryName);
    }, 400);

    return () => clearTimeout(delay);
  }, [searchQueryName]);

  // ================= DELETE =================
  const deleteProduct = (_id) => {
    fetch(`${GET_CAT_API_BASE_URL}/deleteproduct/${_id}`, {
      method: "DELETE",
    })
      .then((res) => res.json())
      .then(() => {
        toast.success("Product deleted");
        setProduct((prev) => prev.filter((p) => p._id !== _id));
      });
  };

  // ================= EDIT =================
  const handleEdit = (_id) => {
    setEditItemId(_id);
    setEditedProduct(productData.find((p) => p._id === _id));
    setEditMode(true);
    setProShowModal(true);
  };

  // ================= VIEW =================
  const handleView = (_id) => {
    setSelectView(productData.find((p) => p._id === _id));
    setOpenModel(true);
  };

  return (
    <div className="p-6 text-white">

      {/* ===== Header ===== */}
      <div className="bg-[#1F2A40] rounded-xl px-6 py-5 flex justify-between items-center mb-6">
        <div>
          <h2 className="text-xl font-semibold">Product Management</h2>
          <p className="text-sm text-green-400">
            Create, update & manage products
          </p>
        </div>

        <button
          onClick={() => {
            setEditMode(false);
            setEditedProduct(null);
            setProShowModal(true);
          }}
          className="bg-emerald-500 hover:bg-emerald-600 px-5 py-2 rounded-lg font-semibold text-sm"
        >
          + Add Product
        </button>
      </div>

      {/* ===== Search ===== */}
      <div className="mb-4">
        <input
          type="text"
          placeholder="Search product name"
          value={searchQueryName}
          onChange={(e) => setSearchQueryName(e.target.value)}
          className="bg-[#141B2D] border border-gray-700 px-4 py-2 rounded-md w-72 outline-none focus:border-indigo-500"
        />
      </div>

      {/* ===== Table ===== */}
      <div className="bg-[#1F2A40] rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#3E4396]">
            <tr>
              <th className="px-5 py-3 text-left">#</th>
              <th className="px-5 py-3 text-left">Category</th>
              <th className="px-5 py-3 text-left">SubCategory</th>
              <th className="px-5 py-3 text-left">Product</th>
              <th className="px-5 py-3 text-left">Price</th>
              <th className="px-5 py-3 text-left">Discount</th>
              <th className="px-5 py-3 text-center">Image</th>
              <th className="px-5 py-3 text-center">Action</th>
            </tr>
          </thead>

          <tbody>
            {productData.length === 0 ? (
              <tr>
                <td colSpan="8" className="text-center py-6 text-gray-400">
                  No products found
                </td>
              </tr>
            ) : (
              productData.map((p, i) => (
                <tr
                  key={p._id}
                  className="border-b border-gray-700 hover:bg-[#2A344D] transition"
                >
                  <td className="px-5 py-3">{i + 1}</td>

                  <td className="px-5 py-3 text-green-400">
                    {p.MaincategoryName}
                  </td>

                  <td className="px-5 py-3 text-green-400">
                    {p.subcategoryName}
                  </td>

                  <td className="px-5 py-3">{p.pName}</td>

                  <td className="px-5 py-3">₹ {p.price}</td>

                  <td className="px-5 py-3">₹ {p.discountPrice}</td>

                  <td className="px-5 py-3 text-center">
                    {p.pImg?.length ? (
                      <img
                        src={`http://localhost:8500/uploads/${p.pImg[0]}`}
                        alt="product"
                        className="w-12 h-12 rounded-lg object-cover mx-auto border border-gray-600"
                      />
                    ) : (
                      <span className="text-gray-400 text-xs">No Image</span>
                    )}
                  </td>

                  <td className="px-5 py-3">
                    <div className="flex justify-center gap-4">
                      <IoEyeSharp
                        className="text-blue-400 cursor-pointer"
                        size={18}
                        onClick={() => handleView(p._id)}
                      />
                      <FaEdit
                        className="text-green-500 cursor-pointer"
                        size={16}
                        onClick={() => handleEdit(p._id)}
                      />
                      <FaTrash
                        className="text-red-500 cursor-pointer"
                        size={16}
                        onClick={() => deleteProduct(p._id)}
                      />
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* ===== Pagination ===== */}
      <div className="flex justify-end mt-4">
        <ReactPaginate
          pageCount={totalPages}
          onPageChange={(e) => setCurrentPage(e.selected + 1)}
          containerClassName="flex gap-2"
          pageClassName="px-3 py-1 border border-gray-700 rounded text-white"
          activeClassName="bg-indigo-600"
        />
      </div>

      {/* ===== Modal ===== */}
      {proShowModal && (
        <ProductModal
          proShowModal={proShowModal}
          shoproShowModal={() => setProShowModal(false)}
          editMode={editMode}
          editedProduct={editedProduct}
          updateProductData={setProduct}
        />
      )}
    </div>
  );
};

export default GetProduct;
